import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {CompositeProductData} from "./composite-product.data";

@Injectable()
export class CompositeProductEntityModel extends EntityModel<CompositeProductData> {

    constructor(injector: Injector) {
        super(injector, CompositeProductData);
    }
}
